import { makeStyles } from '@material-ui/styles'
import React from 'react'
import TrendGraphWidget from '../../../../core/components/widgets/TrendGraphWidget'
import Card from 'core/elements/card'
import CardBody from 'core/elements/card/CardBody'
import Theme from 'core/themes/model'
import { METRICS_API_KEYS } from 'core/components/widgets/useTrendData'
import Text from 'core/elements/Text'
import Divider from 'core/elements/Divider'

const useStyles = makeStyles((theme: Theme) => ({
  hostCards: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(360px, 1fr))',
    gap: theme.spacing(1.5),
    margin: theme.spacing(3, 0, 2),
  },
  cardWrapper: {
    marginTop: theme.spacing(1),
  },
  card: {
    display: 'grid',
    gridTemplateRows: 'max-content max-content',
  },
  cardBody: {
    display: 'grid',
    justifyItems: 'center',
    paddingBottom: 32,
    '& path[name="unknown"]': {
      stroke: theme.components.graph.stroke,
      fill: theme.components.graph.tray,
    },
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
}))

const UsageMetrics = () => {
  const classes = useStyles()
  const networkMetrics = [
    {
      title: 'Data Receive Rate',
      units: 'Kbps',
      metricKey: METRICS_API_KEYS.ALL_HOSTS_NETWORK_RX_THROUGHPUT,
    },
    {
      title: 'Data Transmit Rate',
      units: 'Kbps',
      metricKey: METRICS_API_KEYS.ALL_HOSTS_NETWORK_TX_THROUGHPUT,
    },
  ]
  const storageMetrics = [
    {
      title: 'Disk Read IOPS',
      units: 'IOPS',
      metricKey: METRICS_API_KEYS.ALL_VMS_DISK_READ_IOPS,
    },
    {
      title: 'Disk Write IOPS',
      units: 'IOPS',
      metricKey: METRICS_API_KEYS.ALL_VMS_DISK_WRITE_IOPS,
    },
  ]

  const renderCard = (resource: any) => {
    return (
      <Card className={classes.card} withCustomBody>
        <CardBody>
          <TrendGraphWidget
            title={resource.title}
            units={resource.units}
            metricKey={resource.metricKey}
          />
        </CardBody>
      </Card>
    )
  }

  return (
    <>
      <div className={classes.cardWrapper}>
        {/* <Text variant="subtitle2">Storage</Text>
        <Divider className={classes.divider} /> */}
        <div className={classes.hostCards}>
          {storageMetrics.map((resource) => renderCard(resource))}
        </div>
      </div>
      <div className={classes.cardWrapper}>
        <Text variant="subtitle2">Network</Text>
        <Divider className={classes.divider} />
        <div className={classes.hostCards}>
          {networkMetrics.map((resource) => renderCard(resource))}
        </div>
      </div>
    </>
  )
}

export default UsageMetrics
